import themeVariables from "@Theme/exportColor.module.scss";

const EyeFactsIcon = ({ fill = themeVariables.info5, width = 14, height = 12 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 12"
    fill={fill}
  >
    <g clipPath="url(#clip0_319_17026)">
      <path
        d="M7.2499 0.75C5.35615 0.75 3.83975 1.6125 2.73584 2.63906C1.63896 3.65625 0.905371 4.875 0.558496 5.71172C0.481152 5.89687 0.481152 6.10312 0.558496 6.28828C0.905371 7.125 1.63896 8.34375 2.73584 9.36094C3.83975 10.3875 5.35615 11.25 7.2499 11.25C9.14365 11.25 10.6601 10.3875 11.764 9.36094C12.8608 8.34141 13.5944 7.125 13.9437 6.28828C14.021 6.10312 14.021 5.89687 13.9437 5.71172C13.5944 4.875 12.8608 3.65625 11.764 2.63906C10.6601 1.6125 9.14365 0.75 7.2499 0.75ZM3.8749 6C3.8749 5.10489 4.23048 4.24645 4.86342 3.61351C5.49635 2.98058 6.3548 2.625 7.2499 2.625C8.14501 2.625 9.00345 2.98058 9.63639 3.61351C10.2693 4.24645 10.6249 5.10489 10.6249 6C10.6249 6.89511 10.2693 7.75355 9.63639 8.38649C9.00345 9.01942 8.14501 9.375 7.2499 9.375C6.3548 9.375 5.49635 9.01942 4.86342 8.38649C4.23048 7.75355 3.8749 6.89511 3.8749 6ZM7.2499 4.5C7.2499 5.32734 6.57725 6 5.7499 6C5.5835 6 5.42412 5.97187 5.27412 5.92266C5.14522 5.88047 4.99521 5.96016 4.9999 6.09609C5.00693 6.25781 5.03037 6.41953 5.0749 6.58125C5.396 7.78125 6.63115 8.49375 7.83115 8.17266C9.03115 7.85156 9.74365 6.61641 9.42256 5.41641C9.1624 4.44375 8.30225 3.78984 7.346 3.75C7.21006 3.74531 7.13037 3.89297 7.17256 4.02422C7.22178 4.17422 7.2499 4.33359 7.2499 4.5Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_319_17026">
        <rect width={width} height={height} fill={fill} transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
export default EyeFactsIcon;
